// extracted by mini-css-extract-plugin
export default {"imageContainer":"ImageModal_imageContainer__8orwu","image":"ImageModal_image__pcv96"};